import { curveCardinal, curveLinear, curveMonotoneX, curveMonotoneY, curveNatural } from '@vx/curve';
export default {
  linear: curveLinear,
  cardinal: curveCardinal,
  monotoneX: curveMonotoneX,
  monotoneY: curveMonotoneY,
  natural: curveNatural
};